export default __webpack_public_path__ + "static/media/internet.4a6c1840.svg";